/* Sedelune — interacciones propias (prefijo mt-) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Parte titulares en palabras para animarlas una a una */
  function initSplit(root) {
    root.querySelectorAll('.mt-split:not([data-mt-split])').forEach(function (el) {
      el.setAttribute('data-mt-split', '');
      var i = 0;
      function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span'); w.className = 'mt-w';
              var s = document.createElement('span'); s.textContent = part;
              s.style.setProperty('--mt-wi', i++);
              w.appendChild(s); frag.appendChild(w);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1 && n.tagName !== 'BR') {
            walk(n);
          }
        });
      }
      walk(el);
    });
  }

  /* Un solo observador para todas las entradas */
  var io = null;
  function initReveal(root) {
    var els = root.querySelectorAll('.mt-reveal, .mt-split, .mt-curtain, .mt-mask, [data-mt-observe]');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* Parallax suave (solo transform) */
  var parallaxEls = [];
  function initParallax(root) {
    if (reduce) return;
    root.querySelectorAll('[data-mt-parallax]').forEach(function (el) {
      if (parallaxEls.indexOf(el) === -1) parallaxEls.push(el);
    });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      var movil = window.innerWidth < 750;
      parallaxEls.forEach(function (el) {
        if (movil) { el.style.transform = ''; return; }
        var box = el.parentElement.getBoundingClientRect();
        if (box.bottom < 0 || box.top > vh) return;
        var k = parseFloat(el.getAttribute('data-mt-parallax')) || 0;
        var p = (box.top + box.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * k * -1).toFixed(2) + 'px,0)';
      });
      document.querySelectorAll('.mt-ritual').forEach(updateRitual);
      ticking = false;
    });
  }

  /* Zonas: la tarjeta activa se expande */
  function initZonas(root) {
    root.querySelectorAll('.mt-zonas__grid').forEach(function (grid) {
      var cards = grid.querySelectorAll('.mt-zona');
      function open(c) { cards.forEach(function (x) { x.classList.toggle('is-open', x === c); }); }
      cards.forEach(function (c) {
        c.addEventListener('mouseenter', function () { open(c); });
        c.addEventListener('focus', function () { open(c); });
        c.addEventListener('click', function () { open(c); });
      });
    });
  }

  /* Calor: barra de 9 niveles + temporizador */
  function initCalor(root) {
    root.querySelectorAll('.mt-calor').forEach(function (sec) {
      var bars = sec.querySelectorAll('.mt-nivel');
      var out = sec.querySelector('[data-mt-nivel-valor]');
      var glow = sec.querySelector('.mt-calor__glow');
      var box = sec.querySelector('.mt-niveles');
      function set(n) {
        bars.forEach(function (b, i) {
          b.classList.toggle('is-on', i < n);
          b.classList.toggle('is-sel', i === n - 1);
          b.setAttribute('aria-pressed', i === n - 1 ? 'true' : 'false');
        });
        if (out) out.textContent = n;
        if (glow) glow.style.setProperty('--mt-heat', (0.12 + n * 0.07).toFixed(2));
      }
      bars.forEach(function (b, i) { b.addEventListener('click', function () { set(i + 1); }); });
      var start = parseInt(sec.getAttribute('data-mt-inicio'), 10) || 6;
      if (reduce || !('IntersectionObserver' in window)) { set(start); }
      else {
        set(0);
        var o = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return;
          o.disconnect();
          var n = 0;
          var t = setInterval(function () { n++; set(n); if (n >= start) clearInterval(t); }, 140);
        }, { threshold: 0.4 });
        o.observe(box || sec);
      }
      var chips = sec.querySelectorAll('.mt-chip');
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          chips.forEach(function (x) { x.classList.toggle('is-sel', x === c); x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        });
      });
    });
  }

  /* Ritual: pasos que se activan con el scroll */
  function updateRitual(sec) {
    if (window.innerWidth < 990) return;
    var pasos = sec.querySelectorAll('.mt-paso');
    var linea = sec.querySelector('.mt-pasos__linea');
    var mid = window.innerHeight * 0.5;
    var activo = 0;
    pasos.forEach(function (p, i) { if (p.getBoundingClientRect().top < mid) activo = i; });
    pasos.forEach(function (p, i) { p.classList.toggle('is-activo', i === activo); });
    if (linea) {
      var r = linea.getBoundingClientRect();
      var prog = Math.min(1, Math.max(0, (mid - r.top) / r.height));
      linea.style.setProperty('--mt-prog', prog.toFixed(3));
    }
  }

  /* FAQ con animación de apertura */
  function initFaq(root) {
    root.querySelectorAll('.mt-faq__item').forEach(function (d) {
      if (d.hasAttribute('data-mt-faq')) return;
      d.setAttribute('data-mt-faq', '');
      if (d.open) d.classList.add('is-open');
      var sum = d.querySelector('summary');
      sum.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (d.open) {
          d.classList.remove('is-open');
          setTimeout(function () { d.open = false; }, reduce ? 0 : 450);
        } else {
          d.open = true;
          requestAnimationFrame(function () { d.classList.add('is-open'); });
        }
      });
    });
  }

  /* Producto: galería + variantes + cantidad */
  function initProducto(root) {
    root.querySelectorAll('.mt-pdp').forEach(function (sec) {
      var mains = sec.querySelectorAll('.mt-pdp__main img');
      var thumbs = sec.querySelectorAll('.mt-pdp__thumb');
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.classList.toggle('is-sel', x === t); });
          mains.forEach(function (m, j) { m.classList.toggle('is-sel', j === i); });
        });
      });

      var qty = sec.querySelector('.mt-pdp__qty input');
      sec.querySelectorAll('[data-mt-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-mt-qty'), 10);
          qty.value = Math.max(1, v);
        });
      });

      var dataEl = sec.querySelector('[data-mt-variantes]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var idInput = sec.querySelector('input[name="id"]');
      var priceEl = sec.querySelector('[data-mt-precio]');
      var compareEl = sec.querySelector('[data-mt-comparado]');
      var btn = sec.querySelector('[data-mt-boton]');
      var btnLabel = btn ? btn.querySelector('[data-mt-boton-texto]') : null;
      var txtAdd = btn ? btn.getAttribute('data-texto') : '';
      var txtOut = btn ? btn.getAttribute('data-agotado') : '';
      var fmt = sec.getAttribute('data-mt-moneda') || '${{amount}}';
      function money(c) {
        var n = (c / 100).toFixed(2).split('.');
        var amount = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + n[1];
        return fmt.replace(/\{\{\s*amount\w*\s*\}\}/, amount);
      }
      sec.querySelectorAll('.mt-pdp__opcion input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var sel = [];
          sec.querySelectorAll('.mt-pdp__opcion').forEach(function (fs) {
            var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null);
          });
          var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
          if (!v) { if (btn) btn.disabled = true; return; }
          idInput.value = v.id;
          if (priceEl) priceEl.textContent = money(v.price);
          if (compareEl) {
            compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
          }
          if (btn) { btn.disabled = !v.available; if (btnLabel) btnLabel.textContent = v.available ? txtAdd : txtOut; }
          if (v.featured_media) {
            var idx = -1;
            mains.forEach(function (m, j) { if (m.getAttribute('data-media-id') == v.featured_media.id) idx = j; });
            if (idx > -1 && thumbs[idx]) thumbs[idx].click();
          }
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    });
  }

  /* Antes / después: deslizador */
  function initComparador(root) {
    root.querySelectorAll("[data-mt-comparador]").forEach(function (comp) {
      if (comp.hasAttribute("data-mt-listo")) return;
      comp.setAttribute("data-mt-listo", "");
      var rango = comp.querySelector(".mt-ad__rango");
      var inicio = parseFloat(comp.getAttribute("data-mt-inicio")) || 50;
      function set(v) { comp.style.setProperty("--mt-pos", v + "%"); }
      rango.addEventListener("input", function () { comp.classList.add("is-drag"); set(rango.value); });
      rango.addEventListener("change", function () { comp.classList.remove("is-drag"); });
      if (reduce || !("IntersectionObserver" in window)) return;
      /* pista: el deslizador hace un pequeño barrido al aparecer */
      var o = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        o.disconnect();
        var t0 = null, dur = 3200;
        function paso(ts) {
          if (comp.classList.contains("is-drag")) return;
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur);
          var v = inicio + Math.sin(p * Math.PI) * -42;
          set(v.toFixed(2)); rango.value = v;
          if (p < 1) requestAnimationFrame(paso); else { set(inicio); rango.value = inicio; }
        }
        setTimeout(function () { requestAnimationFrame(paso); }, 500);
      }, { threshold: 0.5 });
      o.observe(comp);
    });
  }

  /* Opiniones: botón «Ver más» */
  function initOpiniones(root) {
    root.querySelectorAll("[data-mt-ver-mas]").forEach(function (btn) {
      if (btn.hasAttribute("data-mt-listo")) return;
      btn.setAttribute("data-mt-listo", "");
      btn.addEventListener("click", function () {
        var sec = btn.closest(".mt-op");
        var grid = sec && sec.querySelector("[data-mt-opiniones]");
        if (grid) grid.classList.add("is-open");
        btn.parentNode.style.display = "none";
        if (grid) grid.querySelectorAll(".mt-op__card--extra").forEach(function (c) { c.classList.add("mt-visible"); });
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initSplit(root);
    initReveal(root);
    initParallax(root);
    initZonas(root);
    initCalor(root);
    initFaq(root);
    initProducto(root);
    initComparador(root);
    initOpiniones(root);
    onScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* Editor de Shopify: re-inicializa al cambiar ajustes */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
